import {
  ErpToIncentive,
} from '@/pages/Admin/HierarchyOfRetailers/CategoryMapping/CategoryMappingModal';

export const doesMappingMatchNames = (
  mapping: ErpToIncentive,
  categoryName?: string | null,
  subcategoryName?: string | null,
) => (
  categoryName === mapping.categoryName
  && (
    subcategoryName === mapping.subcategoryName
    || (!subcategoryName && !mapping.subcategoryName)
  )
);